import { ArrowsExpandIcon } from "@heroicons/react/outline";
import { ChevronsDownUpIcon, ChevronsUpDownIcon } from "lucide-react";
import { ReactNode } from "react";

import { Button } from "@/components/ui/button.tsx";

interface RequestDisplayTemplateViewProps {
  bulkLoaded: boolean;
  hasNoResponse: boolean;
  isChat: boolean;
  multipleChoiceSelector: ReactNode;
  promptDisplay: ReactNode;
  responseDisplay: ReactNode;
  showFullRequest: boolean;
  showFullResponse: boolean;
  onCollapseAll: () => void;
  onExpandAll: () => void;
  onOpenRequestModal: () => void;
  onOpenResponseModal: () => void;
  onToggleShowFullRequest: () => void;
  onToggleShowFullResponse: () => void;
}

export const RequestDisplayTemplateView = ({
  bulkLoaded,
  hasNoResponse,
  isChat,
  multipleChoiceSelector,
  promptDisplay,
  responseDisplay,
  showFullRequest,
  showFullResponse,
  onCollapseAll,
  onExpandAll,
  onOpenRequestModal,
  onOpenResponseModal,
  onToggleShowFullRequest,
  onToggleShowFullResponse,
}: RequestDisplayTemplateViewProps) => (
  <div className="grid h-full min-h-0 grid-cols-2 gap-x-10 overflow-hidden">
    <div className="flex min-h-0 flex-col overflow-y-auto">
      <div className="flex flex-row">
        <h1 className="flex-1 pb-1 text-gray-700">
          Prompt:
          <span
            className="cursor-pointer pl-2 text-xs text-blue-500 hover:text-blue-400"
            onClick={onToggleShowFullRequest}
          >
            {showFullRequest ? "(Show prompt text)" : "(Show full JSON)"}
          </span>
        </h1>
        {isChat && (
          <>
            <button
              type="button"
              className="cursor-pointer text-gray-600 outline-none hover:text-gray-400"
              onClick={onExpandAll}
            >
              <ChevronsUpDownIcon className="mr-1 inline h-5 w-auto" />
            </button>
            <button
              type="button"
              className="cursor-pointer text-gray-600 outline-none hover:text-gray-400"
              onClick={onCollapseAll}
            >
              <ChevronsDownUpIcon className="mr-1 inline h-5 w-auto" />
            </button>
          </>
        )}
        {bulkLoaded ? (
          <button
            type="button"
            className="cursor-pointer text-gray-600 outline-none hover:text-gray-400"
            onClick={onOpenRequestModal}
          >
            <ArrowsExpandIcon className="mr-1 inline h-5 w-auto" />
          </button>
        ) : (
          <Button disabled variant="ghost" size="tinyIcon">
            <ArrowsExpandIcon className="mr-1 inline h-5 w-auto" />
          </Button>
        )}
      </div>
      {promptDisplay}
    </div>
    <div className="flex min-h-0 flex-col overflow-y-auto">
      <div className={`flex flex-row ${multipleChoiceSelector ? "mb-1" : ""}`}>
        <h1 className="flex-1 pb-1 text-gray-700">
          Response:
          {!hasNoResponse && (
            <span
              className="cursor-pointer pl-2 text-xs text-blue-500 hover:text-blue-400"
              onClick={onToggleShowFullResponse}
            >
              {showFullResponse ? "(Show response text)" : "(Show full JSON)"}
            </span>
          )}
        </h1>
        {!hasNoResponse && (!showFullResponse || isChat ? multipleChoiceSelector : null)}
        {!hasNoResponse &&
          (bulkLoaded ? (
            <button className="text-gray-600 hover:text-gray-500" onClick={onOpenResponseModal}>
              <ArrowsExpandIcon className="mr-1 inline h-5 w-auto" />
            </button>
          ) : (
            <Button disabled variant="ghost" size="tinyIcon">
              <ArrowsExpandIcon className="mr-1 inline h-5 w-auto" />
            </Button>
          ))}
      </div>
      {responseDisplay}
    </div>
  </div>
);
